import React from 'react';
import styles from './MenuTitle.module.scss';

export const MenuTitle: React.FC = ({ children }) => {
  return (
    <li>
      <h4 className={styles.title}>{children}</h4>
    </li>
  );
};

export default MenuTitle;
